export default "__VITE_ASSET__D35FSsL1__"